// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"styles_loadingSpinner__IIt61","spin":"styles_spin__n8WK5"};